/**
 * @generated SignedSource<<fdcd3907b02c89850ff93dfb052e723b>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsUserViewingSpaceAsAnonQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useIsUserViewingSpaceAsAnonQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useIsUserViewingSpaceAsAnonQuery = {
  response: useIsUserViewingSpaceAsAnonQuery$data;
  variables: useIsUserViewingSpaceAsAnonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAnonymouslyAuthorized"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsUserViewingSpaceAsAnonQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsUserViewingSpaceAsAnonQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b389961e5e66b422fc68105162ea2a7",
    "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
    "metadata": {},
    "name": "useIsUserViewingSpaceAsAnonQuery",
    "operationKind": "query",
    "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
  }
};
})();

(node as any).hash = "7c791401f0e963cfa78bdcff70a3c87c";

export default node;
